var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"miniDocs_item"},[_c('h4',{staticClass:"miniDocs-industry"},[_vm._v(_vm._s(_vm.projectTitle))]),_c('p',{staticClass:"miniDocs-date"},[_vm._v("Створено: "+_vm._s(_vm.createdAt))]),_c('router-link',{staticClass:"miniDocs-practice",attrs:{"to":{
            name: 'documents-id',
            params: {
                id: _vm.docData.id,
            },
        },"tag":"a"}},[_vm._v(_vm._s(_vm.docData.title))]),(_vm.docData.material && _vm.docData.material.name)?_c('p',{staticClass:"miniDocs-material"},[_vm._v(" "+_vm._s(_vm.docData.material.name)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }